<main class="d-flex flex-column" style="width: 100%;">
  <app-nav-menu></app-nav-menu>
 
  <div class="d-flex flex-column" style="overflow-y: auto; overflow-x: hidden; position: relative; height: 100%;">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</main>
<app-alerts></app-alerts>
